import SearchSelect from "./SearchSelect"

/**
 * Picking a person, by typing.
 *
 * Matched on the email and the username as well as the name, because an
 * organization of any size has two people who share a first name and the thing
 * that tells them apart is the address. The second line carries whichever of
 * the organization or the email is available, for the same reason: "Dana" twice
 * in a list is a coin toss.
 *
 * Used for the owner of a project and the assignee of a task, which are the two
 * questions a filter bar asks about people.
 *
 * `onSearch` matters more here than anywhere else: the staff directory is
 * served one page at a time, so a picker that only filtered what it was handed
 * would tell somebody their colleague does not exist.
 */
export default function PersonSelect({ people = [], label = "Owner", emptyLabel = "Anyone", ...rest }) {
  return (
    <SearchSelect
      options={people}
      label={label}
      emptyLabel={emptyLabel}
      getLabel={(person) => person?.name || person?.username || person?.email || ""}
      getCaption={(person) => person?.organization_label || person?.email || null}
      getSearchText={(person) => `${person.email ?? ""} ${person.username ?? ""} ${person.organization_label ?? ""}`}
      noOptionsText="Nobody matches"
      {...rest}
    />
  )
}
